var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPlusGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "17BEA577-EA09-4071-9433-B1C9512BDAA1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M\\u0101c\\u012Bbu-grupas---Atv\\u0113rums",
    transform: "translate(-1068.000000, -190.000000)",
    fill: "#515C66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-content",
    transform: "translate(260.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(30.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(762.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(16.000000, 10.011264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 0.989987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.58620476 16,8.01001252 C16,12.4338203 12.418278,16.020025 8,16.020025 C3.581722,16.020025 0,12.4338203 0,8.01001252 C0,3.58620476 3.581722,0 8,0 Z M8,4.00500626 C7.44771525,4.00500626 7,4.45328185 7,5.00625782 L7,7.0077597 L5,7.00876095 C4.44771525,7.00876095 4,7.45703655 4,8.01001252 C4,8.56298849 4.44771525,9.01126408 5,9.01126408 L7,9.01026283 L7,11.0137672 C7,11.5667432 7.44771525,12.0150188 8,12.0150188 C8.55228475,12.0150188 9,11.5667432 9,11.0137672 L9,9.01026283 L11,9.01126408 C11.5522847,9.01126408 12,8.56298849 12,8.01001252 C12,7.45703655 11.5522847,7.00876095 11,7.00876095 L9,7.0077597 L9,5.00625782 C9,4.45328185 8.55228475,4.00500626 8,4.00500626 Z",
    id: "icon"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusGrey);
export default __webpack_public_path__ + "static/media/ic-plus-grey.b6af2f4f73117af9f0c70c0113431ab2.svg";
export { ForwardRef as ReactComponent };